import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * The SmartSign brand footer.
 *
 * The React half of one footer definition — the backend renders the same two
 * lines and the same shield into every SmartSign email and into the
 * sender-verify pages (`signFooter` in src/utils/email/sign-brand.ts). Email
 * needs table markup and this needs JSX, so the markup cannot literally be
 * shared; the wording, the mark and the colours are what must not drift, and
 * three hand-written copies is how they did.
 *
 * "Secured by", not the email's "Sent securely via": nothing was sent to
 * somebody reading a page.
 *
 * Deliberately not a link, matching the emails. An unsolicited request for a
 * signature is exactly the shape a phishing attempt takes, so this names the
 * product and stops — which is also why it does not carry SmartForm's
 * "Get started" call to action.
 */
export default function SmartSignFooter({ className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-2.5 px-8 py-3.5 ${className}`}>
      <ShieldCheck size={30} strokeWidth={2} className='flex-shrink-0 text-blue-600' aria-hidden='true' />
      <div>
        <div className='text-xs leading-normal text-slate-500'>
          Secured by <span className='font-medium text-blue-600'>SmartSign</span>
        </div>
        <div className='text-[10px] leading-tight text-slate-300'>SmartSign for monday.com</div>
      </div>
    </div>
  );
}
